/**
 * 接口模块,主要封装了请求
 * @module packages/common/Api
 */

import { Http } from '../../common'
import { ApiError } from './error'
export class Api {
  constructor (domain = process.env.API_DOMAIN) {
    this._domain = domain
  }

  /**
   * 调用接口
   * @function
   * @tutorial common-api-call
   * @name call
   * @param {string} api api字符串,'admin.user.login'
   * @param {*} params 调用参数
   * @returns {Promise}
   */
  call (api, params) {
    const url = this.api2url(api)
    const p = this._params(params)

    return Http.post(url, p).then(response => {
      if (!response || !response.data) {
        return Promise.reject(new ApiError('network error response', -1))
      }

      const data = response.data

      if (!data || typeof data !== 'object' || !data.hasOwnProperty('state')) {
        return Promise.reject(new ApiError('network error format', -1))
      }

      if (data.state && data.state === 1) {
        return Promise.resolve(data.data)
      }

      if (!data.hasOwnProperty('state') || !data.hasOwnProperty('msg')) {
        return Promise.reject(new ApiError('network error format', -1))
      }

      if (data.state && data.state === 3006) {
        // redirectLogin()
        return
      }

      alert(data.msg)
      return Promise.reject(new ApiError(data.msg, data.state))
    })
  }

  callIm (api, params) {
    const imDomain = process.env.IM_API_DOMAIN
    const url = this.api2url(api, imDomain)
    const p = this._params(params)

    return Http.post(url, p).then(response => {
      if (!response || !response.data) {
        return Promise.reject(new ApiError('network error response', -1))
      }

      const data = response.data
      if (!data || typeof data !== 'object' || !data.hasOwnProperty('ret')) {
        return Promise.reject(new ApiError('network error format', -1))
      }

      if (data.ret && data.ret === 1) {
        return Promise.resolve(data.data)
      }

      if (!data.hasOwnProperty('ret') || !data.hasOwnProperty('msg')) {
        return Promise.reject(new ApiError('network error format', -1))
      }

      return Promise.reject(new ApiError(data.msg, data.ret))
    })
  }

  api2url (api, host) {
    let domain = this._domain
    let indexPHP = 'index.php'
    if (host) {
      domain = host
      indexPHP = ''
    }
    const apiArr = api.split('.')

    if (apiArr.length < 2) {
      throw `error api ${api}`
    }

    if (apiArr.length === 2) {
      return `${domain}/${indexPHP}/${apiArr[0]}/${apiArr[1]}`
    }

    if (apiArr.length === 3) {
      return `${domain}/${indexPHP}/${apiArr[0]}/${apiArr[1]}/${apiArr[2]}`
    }

    if (apiArr.length > 3) {
      return `${domain}/${indexPHP}/${apiArr[0]}/${apiArr[1]}/${apiArr[2]}/${
        apiArr[3]
      }.json`
    }
  }

  _params (params) {
    if (!params || typeof params !== 'object') {
      params = {}
    }

    return params
  }
}

const api = new Api()
export default api



// WEBPACK FOOTER //
// ./src/common/api/api.js